import {Button, FormControl, InputGroup} from "react-bootstrap";
import React, {useState} from "react";
import Translate from "../utils/utils";
import {injectIntl} from "react-intl";

const Search = (props) => {

    const {
        onType, onSubmit, onClear, disabled = false, value, intl
    } = props;

    const [searchTerm, setSearchTerm] = useState(value || '');
    const [isDirty, setIsDirty] = useState(false);

    const handleChange = (e) => {
        const {target: {value}} = e;
        setSearchTerm(value);
        onType(e);
        setIsDirty(true);
    };

    const search = () => {
        if (searchTerm !== undefined && searchTerm.length) {
            onSubmit(isDirty);
            setIsDirty(true);
        }
    };

    const clear = (e) => {

        if (searchTerm !== undefined && searchTerm.length) {
            setSearchTerm('');
            onClear(isDirty);
            setIsDirty(false);
        }

    };

    const handleKeyPress = (e) => {
        const code = e.keyCode || e.which;
        if (code === 13) {
            search();
        }
        // onKeyPress();
    };

    return (
        <InputGroup className="mb-3">
            <FormControl
                placeholder={intl.formatMessage({
                    id: "TABLE.NAME"
                })}
                className="col-lg-4"
                value={searchTerm}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
            />
            <InputGroup.Append>
                <Button variant="outline-secondary" onClick={search} disabled={disabled}>
                    {<Translate id={"SEARCH.SEARCH"}/>}
                    <i className="fa fa-search ml-sm-2" style={{"fontSize": ".7rem"}}/>
                </Button>
            </InputGroup.Append>
            <Button variant="outline-secondary" className="ml-sm-3" onClick={clear} disabled={disabled}>
                {<Translate id={"SEARCH.CLEAR"}/>}
                <i className="fa fa-trash ml-sm-2" style={{"fontSize": ".7rem"}}/>
            </Button>
        </InputGroup>
    );
};

export default injectIntl(Search);